<template>
  <section :id="sectionId" class="sectionWrapper" :class="backgroundTypeClass">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'SectionWrapper',
  props: {
    sectionId: {
      required: false,
      type: String
    },
    isNavy: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundTypeClass () {
      return this.isNavy ? 'sectionWrapper--navy' : ''
    }
  }

}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.sectionWrapper {
  $wrapper: #{&};

  // TODO: Casestudyが増えたら以下は削除する
  //&:not(#{$wrapper}--navy) {
  //  &:nth-of-type(2n) {
  //    background: $lightGray;
  //  }
  //  &:nth-of-type(2n + 1) {
  //    background: $white;
  //  }
  //}

  // TODO: Casestudyが増えたら以下を使用する
   &:not(#{$wrapper}--navy) {
       &:nth-of-type(2n) {
           background: $white;
     }
     &:nth-of-type(2n + 1) {
         background: $lightGray;
     }
   }

  &--navy {
    background: $buildNavy;
  }
  @include bpOnlyPc() {
    width: 100%;
  }
}
</style>
